import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    lists: {},
    total_count: '',
    count: 1,
    list: {},
    listView: {},
    code: '',
    updatedtag_id: '',
    is_no_records: '',
    state_name: '',
    country_name: '',
    updated_id: '',
    imported_records: {},
    statelist: [],
    countrylist: [],
    gsttype: [],
    paymentterm: [],
    currency: [],
    customertaglist: [],
    search_criteria: '',
    delete: {},
    filter_list: {},
    filter_name: '',
    message: {},
    amc_list: {},
    invoice_list: {},
    payment_list: {},
    customer_addr: [],
    quotation_list: {},
    salesorder_list: {},
    package_list: {},
    retainer_list: {},
    recurring_list: {},
    credit_list: {},
    total_amc_list: "",
    total_invoice_list: "",
    total_payment_list: "",
    total_quotation_list: "",
    total_salesorder_list: "",
    total_retainer_list: "",
    total_recurring_list: "",
    total_credit_list: "",
    total_package_list: "",
    creditlist: {},
    statementdetails: "",
    price_list: {},
    export: {},
    address: "",
    currency_list: [],
    currency_details: {},
    exempt_detail: [],
    log_details: '',
    show_modal: '',
    status_code: '',
    status_message: '',
    status_type: '',
    cus_index_history:'',
    index_status:''
}

const mutations = {
    SHOW_MODAL(state, show) {
        state.show_modal = show
    },
    GET_CURRENCY_RATE(state, data) {
        state.currency_details = data;
        state.error = "";
    },
    CUSTOMER_IMPORT_LIST(state, list) {
        state.list = list;
        state.error = "";
    },
    SET_CUS_CREDIT(state, data) {
        state.creditlist.total_due_amt = data.due_amount;
        state.creditlist.cus_credit_limit = data.credit_limit;
        state.creditlist.unused_credits = data.unused_credits;
    },
    SET_DATAS(state, lists) {
        state.lists = lists.customer_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name,
            state.is_no_records = lists.is_no_records
    },
    SET_ADDRESS(state, lists) {
        state.address = lists.address
    },

    CUSTOMER_ADDR(state, data) {
        state.customer_addr = data
    },
    LIST_STATEMENT_DETAILS(state, lists) {
        state.statementdetails = lists

    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    LIST_DATA(state, list) {
        state.list = list
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
    },
    LIST_VIEW_DATA(state, list) {
        state.listView = list
        state.statementdetails = ''
        state.amc_list = {}
        state.invoice_list = {}
        state.payment_list = {}
        state.quotation_list = {}
        state.retainer_list = {}
        state.recurring_list = {}
        state.credit_list = {}
        state.total_amc_list = ""
        state.total_invoice_list = ""
        state.total_payment_list = ""
        state.total_quotation_list = ""
        state.total_retainer_list = ""
        state.total_recurring_list = ""
        state.total_credit_list = ""
    },
    UPDATED_TAG(state, updated_id) {
        state.updatedtag_id = updated_id
    },
    LIST_STATE(state, state_name) {
        state.state_name = state_name
    },
    LIST_IMPORTED_RECORDS(state, data) {
        state.imported_records = data
    },
    LIST_COUNTRY(state, country_name) {
        state.country_name = country_name
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
    },

    LIST_DETAILS(state, data) {
        state.statelist = data.statelist
        state.countrylist = data.countrylist
        state.gsttype = data.gsttype
        state.paymentterm = data.paymentterm
        state.currency = data.currency
        state.price_list = data.price_list
        state.customertaglist = data.customertaglist
        state.currency_list = data.currency_list
        state.exempt_detail = data.exempt_detail;

    },
    TAG_LIST(state, data) {
        state.customertaglist = data
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    DELETE_RESULT(state, delete_result) {
        state.delete = delete_result
    },
    MESSAGE_RESULT(state, message) {
        state.message = message
    },
    TRANSACTION_LIST(state, data) {
        if (data.type == 'amc') {
            state.amc_list = data
        } else if (data.type == 'invoice') {
            state.invoice_list = data
        } else if (data.type == 'retainer') {
            state.retainer_list = data
        } else if (data.type == 'quotation') {
            state.quotation_list = data
        } else if (data.type == 'credit') {
            state.credit_list = data
        } else if (data.type == 'payment') {
            state.payment_list = data
        } else if (data.type == 'recurring') {
            state.recurring_list = data
        } else if (data.type == 'salesorder') {
            state.salesorder_list = data
        } else if (data.type == 'package') {
            state.package_list = data
        }
    },
    TOTAL_CODE(state, data) {
        if (data.type == 'amc') {
            state.total_amc_list = data.cus_total_count
        } else if (data.type == 'invoice') {
            state.total_invoice_list = data.cus_total_count
        } else if (data.type == 'retainer') {
            state.total_retainer_list = data.cus_total_count
        } else if (data.type == 'quotation') {
            state.total_quotation_list = data.cus_total_count
        } else if (data.type == 'credit') {
            state.total_credit_list = data.cus_total_count
        } else if (data.type == 'payment') {
            state.total_payment_list = data.cus_total_count
        } else if (data.type == 'recurring') {
            state.total_recurring_list = data.cus_total_count
        } else if (data.type == 'salesorder') {
            state.total_salesorder_list = data.cus_total_count
        } else if (data.type == 'package') {
            state.total_package_list = data.cus_total_count
        }
    },
    CUSTOMER_CREDIT_LIST(state, data) {
        state.creditlist = data.Unused_credits
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },


}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {


        return AppService.customer.getCustomers(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                } else {
                    commit("SET_CODE", response.data);
                    
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {


        return AppService.customer.getCustomersExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    getCustomerLimit({
        commit,
        rootState
    }, id) {

        return AppService.customer.getCustomerLimit(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_CUS_CREDIT', response.data.cus_amt_details) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    getAddress({
        commit,
        rootState
    }, id) {

        return AppService.customer.getAddress(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_ADDRESS', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerstatementLists({
        commit,
        rootState
    }, data) {


        return AppService.customer.getCustomerStatement(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_STATEMENT_DETAILS', response.data.data.list) // getting all the list in the api call
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    createList({
        commit,
        rootState
    }, list) {

        return AppService.customer.postCustomer(list, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_RESULT', response.data.data) // getting all the list in the api call
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    commit('SHOW_MODAL', response.data.show) // getting all the list in the api call 
                    return response.data
                }


            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    custdelete({
        commit,
        rootState
    }, id) {

        return AppService.customer.postCustdelete(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                    commit('LIST_LOG', response.data)

                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    custstatus({
        commit,
        rootState
    }, data) {

        return AppService.customer.postCuststatus(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('LIST_LOG', response.data);
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importList({
        commit,
        rootState
    }, list) {

        return AppService.customer.postImportCustomer(list, rootState.session.token)
            .then(response => {
                commit('LIST_IMPORTED_RECORDS', response.data.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.customer.postFilterdeleteCustomer(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    //to add additional address
    addresscreate({
        commit,
        rootState
    }, data) {
        return AppService.customer.postaddress(data, rootState.session.token)
            .then(response => {
                commit("SET_CODE", response.data);
                commit('STATUS_CODE', response.status) // getting all the list in the api call
                commit('CUSTOMER_ADDR', response.data.customer_addr)
                commit("MESSAGE_RESULT", response.data.status);
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.customer.postCustomerUpdate(field, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_RESULT', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status)
                    commit('SHOW_MODAL', response.data.show) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, {id,type}) {

        return AppService.customer.getCustomer(id,type, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchViewList({
        commit,
        rootState
    }, id) {

        return AppService.customer.getCustomerView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_VIEW_DATA', response.data.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addTag({
        commit,
        rootState
    }, tag_name) {
        return AppService.customer.postCustomerTag(tag_name, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if(response.status == 201) {
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }else {
                    commit('TAG_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                  
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCustomerDetails({
        commit,
        rootState
    }) {
        return AppService.customer.getCustomerDetails(rootState.session.token)
            .then(response => {
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCustomerFilterDetails({
        commit,
        rootState
    }) {
        return AppService.customer.getCustomerFilterDetails(rootState.session.token)
            .then(response => {
                rootState.general.filterdetails = response.data
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.customer.postFiltercreateCustomer(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.customer.postFilterudpateCustomer(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    // customer transaction view
    fetchcustomeramcview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {

        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomeramcview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    // customer transaction view
    fetchcustomerinvoiceview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerinvoiceview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomersalesorderview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomersalesorderview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerpackageview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerpackageview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomercreditview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomercreditview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerretainerview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerretainerview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerrecurringview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerrecurringview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerpaymentview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerpaymentview(page, show, data, rootState.session.token)
            .then(response => {


                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchcustomerquotationview({
        commit,
        rootState
    }, {
        page,
        show,
        id
    }) {
        var data = JSON.stringify({
            id: id
        });
        return AppService.customer.postCustomerquotationview(page, show, data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('TRANSACTION_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    //  delete customer 
    deletecustomer({
        commit,
        rootState
    }, data) {

        return AppService.customer.getCustomerDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    deleteaddress({
        commit,
        rootState
    }, data) {

        return AppService.customer.getDeleteAddress(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    //  delete customer 
    viewtotalcount({
        commit,
        rootState
    }, data) {

        return AppService.customer.getViewTotalCount(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('TOTAL_CODE', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    //  get unsused credit list from the customer
    postUnusedcreditview({
        commit,
        rootState
    }, data) {

        return AppService.customer.postUnusedcreditview(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('CUSTOMER_CREDIT_LIST', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importcustomervalidation({
        commit,
        rootState
    }, data) {

        return AppService.customer.importcustomervalidation(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('CUSTOMER_IMPORT_LIST', response.data); // getting all the list in the api call
                    return response.data
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importCustomer({
        commit,
        rootState
    }, data) {

        return AppService.customer.importCustomer(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_RESULT', response.data.status); // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateCreditLimit({
        commit,
        rootState
    }, data) {

        return AppService.customer.updateCreditLimit(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('MESSAGE_RESULT', response.data.status); // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    getCurrencyRate({
        commit,
        rootState
    }, data) {

        return AppService.customer.getCurrencyRate(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('GET_CURRENCY_RATE', response.data); // getting all the list in the api call

                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    openingBalanceUpdate({
        commit,
        rootState
    }, data) {
        return AppService.customer
            .openingBalanceUpdate(data, rootState.session.token)
            .then((response) => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit("MESSAGE_RESULT", response.data); // getting all the list in the api call
                    return response
                }
            })
            .catch((error) => {
                if (!error.response) {
                    rootState.general.network_error = 500; // getting all the list in the api call
                }
            });
    },

    addexempt({
        commit,
        rootState
    }, data) {
        return AppService.general
            .postexemptreason(data, rootState.session.token)
            .then((response) => {
                commit("STATUS_CODE", response.status); // getting all the list in the api call
                commit("UPDATED_TAG", response.data.updated_id);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    return response.data;
                } else {
                    rootState.customer.exempt_detail = response.data.data;
                    commit("MESSAGE_RESULT", response.data.status); // getting all the list in the api call
                }
                return response;
            })
            .catch((error) => {
                if (!error.response) {
                    // commit('ERROR_STATUS', 500) // getting all the list in the api call
                }
            });
    },
    checkCustomerExist({
        commit,
        rootState
    }, data) {
        return AppService.customer
            .checkCustomerExist(data, rootState.session.token)
            .then((response) => {


                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("STATUS_CODE", response.status); // getting all the list in the api call
                    return response;
                }
            })
            .catch((error) => {
                if (!error.response) {
                    // commit('ERROR_STATUS', 500) // getting all the list in the api call
                }
            });
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions
}